module.exports = __webpack_public_path__ + "img/bg_detection.1ab2adba.png";